import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Navigation } from './components/Navigation';
import { HomePage } from './pages/HomePage';
import { WhatToSayToCops } from './pages/WhatToSayToCops';
import { TipsAfterCrash } from './pages/TipsAfterCrash';
import { HorribleLaws } from './pages/HorribleLaws';
import { HelmetLaw } from './pages/HelmetLaw';
import { GunLaws } from './pages/GunLaws';
import { MotorcycleLaws } from './pages/MotorcycleLaws';
import { BestRides } from './pages/BestRides';
import { Insurance } from './pages/Insurance';
import { BikerBars } from './pages/BikerBars';
import { Contact } from './pages/Contact';
import { LawsHub } from './pages/LawsHub';
import { RidesHub } from './pages/RidesHub';
const pageVariants = {
  initial: {
    opacity: 0,
    x: 20
  },
  in: {
    opacity: 1,
    x: 0
  },
  out: {
    opacity: 0,
    x: -20
  }
};
const pageTransition = {
  type: 'tween',
  ease: 'easeInOut',
  duration: 0.2
};
function AnimatedRoutes() {
  const location = useLocation();
  return <AnimatePresence mode="wait" data-id="element-0">
      <motion.div key={location.pathname} initial="initial" animate="in" exit="out" variants={pageVariants} transition={pageTransition} className="min-h-screen" data-id="element-1">
        <Routes location={location} data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/laws" element={<LawsHub data-id="element-6" />} data-id="element-5" />
          <Route path="/rides" element={<RidesHub data-id="element-8" />} data-id="element-7" />
          <Route path="/contact" element={<Contact data-id="element-10" />} data-id="element-9" />
          <Route path="/what-to-say-to-cops" element={<WhatToSayToCops data-id="element-12" />} data-id="element-11" />
          <Route path="/tips-after-crash" element={<TipsAfterCrash data-id="element-14" />} data-id="element-13" />
          <Route path="/horrible-laws" element={<HorribleLaws data-id="element-16" />} data-id="element-15" />
          <Route path="/helmet-law" element={<HelmetLaw data-id="element-18" />} data-id="element-17" />
          <Route path="/gun-laws" element={<GunLaws data-id="element-20" />} data-id="element-19" />
          <Route path="/motorcycle-laws" element={<MotorcycleLaws data-id="element-22" />} data-id="element-21" />
          <Route path="/best-rides" element={<BestRides data-id="element-24" />} data-id="element-23" />
          <Route path="/insurance" element={<Insurance data-id="element-26" />} data-id="element-25" />
          <Route path="/biker-bars" element={<BikerBars data-id="element-28" />} data-id="element-27" />
        </Routes>
      </motion.div>
    </AnimatePresence>;
}
export function App() {
  return <BrowserRouter data-id="element-29">
      <div className="max-w-md mx-auto bg-[#0a0a0a] min-h-screen relative" data-id="element-30">
        <AnimatedRoutes data-id="element-31" />
        <Navigation data-id="element-32" />
      </div>
    </BrowserRouter>;
}